export const isTouchScreen = () => {
  return 'ontouchstart' in document.documentElement;
};
